import { render, staticRenderFns } from "./WhatsHappening.vue?vue&type=template&id=5c48d7ba&scoped=true"
import script from "./WhatsHappening.vue?vue&type=script&lang=js"
export * from "./WhatsHappening.vue?vue&type=script&lang=js"
import style0 from "./WhatsHappening.vue?vue&type=style&index=0&id=5c48d7ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48d7ba",
  null
  
)

export default component.exports